// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions
// tslint:disable:no-big-function

import {
  IDynamicInput,
  IDynamicItem,
  IDynamicSimpleText,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

import { createInstanceWithChildren } from '../../utils/dynamic-items-utils';

export function createAnErrorOccurredElements(providers: {
  text: IDynamicInput;
}) {
  const message: IDynamicSimpleText = {
    id: `error-occurred-text`,
    contentTypeId: 'dynamic-elements-simple-text',
    styles: {
      classes: ['message', 'd-block', 'text-center'],
      variables: {
        '--text-dynamic-color': 'var(--dark-mode-gray-600, #414141)',
      },
    },
    inputs: {
      text: providers.text,
    },
  };

  const container = createInstanceWithChildren({
    id: `error-occurred-container`,
    contentTypeId: 'dynamic-collections-renderer',
    if: undefined as IDynamicItem['if'],
    styles: {
      classes: [
        'error-view',
        'd-flex',
        'w-100',
        'flex-column',
        'justify-content-center',
        'align-items-center',
        'h5',
        'text-muted',
      ],
      style: {} as Exclude<
        Exclude<IDynamicItem['styles'], undefined>['style'],
        undefined
      >,
    },
    children: [message],
  });

  return { container, message };
}
